import type { ValidationIssue } from '@floorpoll/shared';

/**
 * Turns a machine path like `screens[1].questions[0].options[2]` into the
 * words the builder UI uses, one-indexed: "Screen 2, question 1, option 3".
 * People count from one; error messages must too.
 */
export function describeIssue(issue: ValidationIssue): string {
  const parts: string[] = [];
  const pattern = /(screens|questions|options)\[(\d+)\]/g;

  for (const [, segment, index] of issue.path.matchAll(pattern)) {
    const label =
      segment === 'screens' ? 'Screen' : segment === 'questions' ? 'question' : 'option';
    parts.push(`${label} ${Number(index) + 1}`);
  }

  return parts.length > 0 ? `${parts.join(', ')}: ${issue.message}` : issue.message;
}
